import { render, staticRenderFns } from "./evaluateTag.vue?vue&type=template&id=4fc1be4c"
import script from "./evaluateTag.vue?vue&type=script&lang=js"
export * from "./evaluateTag.vue?vue&type=script&lang=js"
import style0 from "./evaluateTag.vue?vue&type=style&index=0&id=4fc1be4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports